import './ComingSoon.scss';
import { getAmazonBookHref } from '../components/ShopifyBundleButton';

const ComingSoon = () => {
  const visitorLanguage = navigator.language?.toLowerCase().startsWith('fr') ? 'fr' : 'en';
  const amazonBookHref = getAmazonBookHref(visitorLanguage);

  return (
    <main
      className="coming-soon"
      style={{ '--coming-soon-background': "url('/images/volcanic-coming-soon-bg.webp')" }}
    >
      <header className="coming-soon__header">
        <img
          src="/images/logo.svg"
          alt=""
          className="coming-soon__logo"
          aria-hidden="true"
        />
        <div>
          <p className="coming-soon__brand">Systeria 88 - The Cry of the Rageborn</p>
          <p className="coming-soon__signature">5 worlds. 5 systems of control. 1 exit.</p>
        </div>
      </header>

      <section className="coming-soon__content" aria-label="Systeria 88 book">
        <div className="coming-soon__hero">
          <div className="coming-soon__cover-wrap">
            <img
              src="/images/spiner-cover-en.png"
              alt="Systeria 88 book cover"
              className="coming-soon__cover"
            />
          </div>

          <div className="coming-soon__hero-copy">
            <h2>Hard Reset Your Mental Model (5 Hidden Control Systems)</h2>
            <p className="coming-soon__description">
              Systeria 88 is a dystopian and philosophical novel that exposes the invisible
              conditioning shaping how you think, decide, perceive and restores independent
              thinking.
            </p>

            <div className="coming-soon__amazon">
              <p className="coming-soon__available">Available on</p>
              <img
                src="https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg"
                alt="Amazon"
                className="coming-soon__amazon-logo"
              />
              <a
                href={amazonBookHref}
                target="_blank"
                rel="noopener noreferrer"
                className="coming-soon__book-button"
              >
                Get the book
              </a>
            </div>
          </div>
        </div>
      </section>

      <footer className="coming-soon__footer">
        <a href="https://systeria.systems" target="_blank" rel="noopener noreferrer">
          © 2026 SYSTERIA®
        </a>
      </footer>
    </main>
  );
};

export default ComingSoon;
